import React from 'react'
import { Text } from '@usap/uicomponents'

const TotalPrice = props => {
  const {
    itemTotal, type, showTabs, selectedPart, isDesktop, isWmoEnabled = false,  multipleItemsPresent
  } = { ...props }

  const showItemTotal = (type === 'noSelectedPartAndNotDesktop' && !selectedPart && !isDesktop)
  || (type === 'showTabAndSelectedPart' && showTabs && selectedPart)

  if(isWmoEnabled) {
    return showItemTotal && (
      <Text
        color="dark-2"
        style={{ fontSize: isDesktop ? "16px" : "14px", fontWeight: 600 }}
        margin={multipleItemsPresent ? null: { top: "16px" }}
      >
        {'Item Total: '}
          $
          {itemTotal}
      </Text>
    )
  }

  return showItemTotal && (
    <Text
      size="small"
      color="#333333"
      style={{ fontWeight: 500, height: '24px' }}
    >
      {'Item Total: '}
      <strong>
        $
        {itemTotal}
      </strong>
    </Text>
  )
}

export default TotalPrice
